import React from 'react';
import { useTranslation } from 'react-i18next';
import Paragraph from '@features/_common/components/Paragraph/Paragraph';
import { Link } from 'react-router-dom';
import style from './legal.module.scss';

export default function LegalPage() {
  const { t } = useTranslation('legal\\Legal');

  return (
    <main className={style.container}>
      <h1 className={style.title}>{t('legalTitle')}</h1>
      <Paragraph title={t('legalProperty')} text={t('legalPropertyP1')} />

      <Paragraph
        title={t('legalResponsibility')}
        text={t('legalResponsibilityP1')}
      />
      <Paragraph text={t('legalResponsibilityP2')} />

      <Paragraph
        title={t('legalReproduction')}
        text={t('legalReproductionP1')}
      />

      <Paragraph title={t('legalLaw')} text={t('legalLawP1')} />
      <Paragraph text={t('legalLawP2')} />
      <Paragraph text={t('legalLawP3')} />

      <Paragraph title={t('legalLaw')} text={t('legalLawP1')} />
      <Paragraph text={t('legalLawP2')} />
      <Paragraph text={t('legalLawP3')} />
      <Link className={style.link} to={t('legalLawLink')} target="_blank">
        {t('legalLawLink')}
      </Link>

      <Paragraph title={t('legalCookies')} text={t('legalCookiesP1')} />
      <Paragraph text={t('legalCookiesP2')} />

      <Paragraph title={t('legalMinors')} text={t('legalMinorsP1')} />

      <Paragraph title={t('legalRights')} text={t('legalRightsP1')} />
      <Paragraph text={t('legalRightsP2')} />
      <Paragraph text={t('legalRightsP3')} />
    </main>
  );
}
